module.exports = __webpack_public_path__ + "assets/img/career-office.61c221c0.webp";